// This routes are used in the dashboard-frontend and frontend-customer-detail old routes are still supported, don't change them. A test is set in frontend-customer-detail to double check any changes.
export const customerDetailPrePaths = {
  customer: '/customer',
  oldCustomer: '/stats/customers',
  customerPhone: '/customer-phone',
  oldCustomerPhone: '/stats/customers-phone',
  customerEmail: '/customer-email',
  oldCustomerEmail: '/stats/customers-email',
  customerIpAddress: '/customer-ip-address',
  oldCustomerIpAddress: '/stats/customers-ip-address',
  customerDomain: '/customer-domain',
  customerLogin: '/customer-login',
  customerLoginEnrollment: '/customer-login/enrollment',
  customerBotDetection: '/customer-bot-detection',
};

export const avatarImgSize = 55;
